export const idPrefix = 'react-hook-consent';
export const localStorageKey = 'react-hook-consent';
